import React from 'react';

export default function BlogImageBlock({ data }) {
  const { image, alt, height = '600px', overlay = 'none' } = data || {};
  if (!image) return null;

  const overlayStyle = {
    none: 'none',
    'gradient-left': 'linear-gradient(to right, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 60%)',
    'gradient-center': 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3))',
  };

  return (
    <div className="blog-image-block" style={{ position: 'relative', width: '100%', height, overflow: 'hidden' }}>
      <img
        src={image}
        alt={alt || ''}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
      {overlay !== 'none' && (
        <div style={{
          position: 'absolute',
          inset: 0,
          background: overlayStyle[overlay] || 'none',
          pointerEvents: 'none',
        }} />
      )}
    </div>
  );
}
